import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import formatBRL from "../../../shared/utils/formatBRL";

const COLORS = ["#111111", "#c9bfb3", "#e8e3dc", "#8a8178", "#f4f1ec"];

/** Card "Canais de venda" (rosca + legenda) — `data` vem de salesByChannel(). */
const SalesChannelsChart = ({ data = [] }) => {
  const total = data.reduce((s, c) => s + c.value, 0);

  return (
    <section className="sales-card sales-channels">
      <header className="sales-card__header">
        <h2 className="sales-card__title">Canais de venda</h2>
      </header>

      {data.length === 0 ? (
        <p className="sales-empty">Sem vendas nesse período.</p>
      ) : (
        <div className="sales-channels__body">
          <div className="sales-channels__donut">
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={data}
                  dataKey="value"
                  nameKey="name"
                  innerRadius="68%"
                  outerRadius="100%"
                  startAngle={90}
                  endAngle={-270}
                  stroke="none"
                  isAnimationActive={false}
                >
                  {data.map((c, i) => (
                    <Cell key={c.name} fill={COLORS[i % COLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="sales-channels__center">
              <span>Total</span>
              <strong>{formatBRL(total)}</strong>
            </div>
          </div>

          <ul className="sales-channels__legend">
            {data.map((c, i) => (
              <li key={c.name}>
                <span
                  className="sales-channels__dot"
                  style={{ background: COLORS[i % COLORS.length] }}
                />
                <span className="sales-channels__name">{c.name}</span>
                <span className="sales-channels__percent">
                  {c.percent.toFixed(1).replace(".", ",")}%
                </span>
                <span className="sales-channels__value">
                  {formatBRL(c.value)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default SalesChannelsChart;
